<div ctExtractionOcrFormInput [activeField]="currentActiveField()">
  <div class="border-b-theme-blue-gray h-fit w-full border-b p-4">
    <span class="text-lg font-bold">
      Bitte erfasse die Informationen des Behandler des markierten Dokuments:
    </span>
  </div>

  <div class="flex h-full min-h-0 flex-col gap-4">
    @for (section of sections; track section.key) {
      <ct-extraction-field-group-extraction-view
        [isConsolidation]="false"
        [headerIcon]="section.icon"
        [inputWidth]="'width-1-3-without-gap'"
        [fieldGroupModel]="section"
        [currentFieldModel]="currentActiveFieldModel()"
        [focusInputs]="true"
        [prefillResults]="initData()"
        [isActiveSection]="currentActiveSection() === section"
        (valueChange)="saveFieldGroupValues($event)"
        (currentExtractionFieldChange)="onCurrentExtractionFieldChange(section, $event)">
      </ct-extraction-field-group-extraction-view>
    }

    <div class="flex w-full flex-row gap-4">
      <button
        type="button"
        sharedCoreButton
        variant="secondary"
        class="w-full"
        id="button-cancel-behandler-data"
        [attr.data-testid]="'button-cancel-behandler-data'"
        (click)="onClickCancel()">
        {{ persistDataService.behandlerData.length ? 'Abbrechen' : 'Keinem Behandler zuweisen' }}
      </button>

      <button
        type="button"
        id="button-confirm-behandler-data"
        [disabled]="disableConfirmDataButton()"
        [attr.data-testid]="'button-confirm-behandler-data'"
        sharedCoreButton
        variant="primary"
        class="w-full"
        [sharedCoreTooltip]="
          disableConfirmDataButton()
            ? 'Bitte gib den Namen der Einrichtung oder des Behandlers an'
            : ''
        "
        (click)="onClickConfirmData()">
        <img
          [ngSrc]="'@shared/circle-check-solid.svg'"
          class="mr-4 ml-2"
          width="20"
          height="20"
          alt="Daten bestätigen" />
        <span>Daten bestätigen</span>
      </button>
    </div>
  </div>
</div>
